konnyScript(function($){
  
    /* 상품진열슬라이드 1번 */
    var swiper = new Swiper('#read_prd_slide1', {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        scrollbar: {
            el:'#read_prd_slide1 .swiper-scrollbar',
        },
        pagination: {
            el:'#read_prd_slide1 .swiper-pagination',
        },
    });
    
    /* 상품진열슬라이드 2번 */
    var swiper = new Swiper('#read_prd_slide2', {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        scrollbar: {
            el:'#read_prd_slide2 .swiper-scrollbar',
        },
        pagination: {
            el:'#read_prd_slide2 .swiper-pagination',
        },
    });
    
    /* 상품진열슬라이드 3번 */
    var swiper = new Swiper('#read_prd_slide3', {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        scrollbar: {
            el:'#read_prd_slide3 .swiper-scrollbar',
        },
        pagination: {
            el:'#read_prd_slide3 .swiper-pagination',
        },
    });
   
});